import React, { useContext } from 'react'
import { EditorContext } from '../../../../../../../components/CanvasEditor/Context/EditorProvider'

const Fonts = () => {

  const { textEditorOptions, setTextEditorOptions } = useContext(EditorContext);

  const handleChange = (e) => {
    setTextEditorOptions({ ...textEditorOptions, fontFamily: e.target.value });
  }

  return (
    <div className='fonts' data-toggle="tooltip" data-placement="top" title="Font Family">
      <select style={{fontFamily: textEditorOptions.fontFamily}} onChange={handleChange}>
        <option style={{fontFamily: 'arial'}} value="arial">Arial</option>
        <option style={{fontFamily: 'helvetica'}} value="helvetica">Helvetica</option>
        <option style={{fontFamily: 'myriad pro'}} value="myriad pro">Myriad Pro</option>
        <option style={{fontFamily: 'delicious'}} value="delicious">Delicious</option>
        <option style={{fontFamily: 'verdana'}} value="verdana">Verdana</option>
        <option style={{fontFamily: 'georgia'}} value="georgia">Georgia</option>
        <option style={{fontFamily: 'courier'}} value="courier">Courier</option>
        <option style={{fontFamily: 'comic sans ms'}} value="comic sans ms">Comic Sans MS</option>
        <option style={{fontFamily: 'impact'}} value="impact">Impact</option>
        <option style={{fontFamily: 'monaco'}} value="monaco">Monaco</option>
        <option style={{fontFamily: 'monospace'}} value="monospace">Monospace</option>
        <option style={{fontFamily: 'optima'}} value="optima">Optima</option>
        <option style={{fontFamily: 'hoefler text'}} value="hoefler text">Hoefler Text</option>
        <option style={{fontFamily: 'plaster'}} value="plaster">Plaster</option>
        <option style={{fontFamily: 'engagement'}} value="engagement">Engagement</option>
      </select>
    </div>
  )
}

export default Fonts